/**
 * The logo's letters: chunky blocks, seven rows tall, vertical strokes two blocks wide and
 * horizontals one, like the C64's fat pixels. Rows are separated by `|`. Pure data.
 */

export const LOGO_ROWS = 7;

export const LOGO_FONT: Readonly<Record<string, string>> = {
  A: '.####.|##..##|##..##|######|##..##|##..##|##..##',
  B: '#####.|##..##|##..##|#####.|##..##|##..##|#####.',
  C: '.#####|##....|##....|##....|##....|##....|.#####',
  D: '#####.|##..##|##..##|##..##|##..##|##..##|#####.',
  E: '######|##....|##....|#####.|##....|##....|######',
  F: '######|##....|##....|#####.|##....|##....|##....',
  G: '.#####|##....|##....|##.###|##..##|##..##|.####.',
  H: '##..##|##..##|##..##|######|##..##|##..##|##..##',
  I: '##|##|##|##|##|##|##',
  J: '....##|....##|....##|....##|....##|##..##|.####.',
  K: '##..##|##.##.|####..|###...|####..|##.##.|##..##',
  L: '##....|##....|##....|##....|##....|##....|######',
  M: '##....##|###..###|########|##.##.##|##....##|##....##|##....##',
  N: '##..##|###.##|######|##.###|##..##|##..##|##..##',
  O: '.####.|##..##|##..##|##..##|##..##|##..##|.####.',
  P: '#####.|##..##|##..##|#####.|##....|##....|##....',
  Q: '.####.|##..##|##..##|##..##|##.###|.####.|....##',
  R: '#####.|##..##|##..##|#####.|####..|##.##.|##..##',
  S: '.#####|##....|##....|.####.|....##|....##|#####.',
  T: '######|..##..|..##..|..##..|..##..|..##..|..##..',
  U: '##..##|##..##|##..##|##..##|##..##|##..##|.####.',
  V: '##..##|##..##|##..##|##..##|##..##|.####.|..##..',
  W: '##....##|##....##|##....##|##.##.##|########|###..###|##....##',
  X: '##..##|##..##|.####.|..##..|.####.|##..##|##..##',
  Y: '##..##|##..##|##..##|.####.|..##..|..##..|..##..',
  Z: '######|....##|...##.|..##..|.##...|##....|######',
  ' ': '....|....|....|....|....|....|....',
};

/** A letter's rows; unknown characters are a solid block, so a renamed game still gets a logo. */
export function logoGlyph(ch: string): readonly string[] {
  const g = LOGO_FONT[ch.toUpperCase()] ?? '######|######|######|######|######|######|######';
  return g.split('|');
}
